import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { FaqCategory } from '../../models/faq/faq-category-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class FaqCategoryService {
  
  private serviceName = 'api/faqCategory'
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  

  addFaqCategory(FaqCategorymodel: FaqCategory) {
    return this.http
      .post(`${this.serviceName}`, FaqCategorymodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateFaqCategory(FaqCategoryModel: FaqCategory) {
    return this.http
      .put(`${this.serviceName}`, FaqCategoryModel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  SaveFaqCategoryIcon(formData: any,userId:number): void {
    this.http
      .post(`${this.serviceName}/SaveFaqCategoryIcon?userId=` + userId, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
      });
  }
  deleteFaqCategory(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getFaqCategories() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getFaqCategory(id : string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/faq/faq-category.service.ts